<div class="checkout-payment-container">
  <div class="content">
    <div class="headline">{{ 'checkout.steps.payment.headline' | translate }}</div>
    <kion-payment-item
      (selected)="paymentSelected($event)"
      *ngFor="let payment of payments$ | async"
      [hasIframe]="!!payment.paymentConfiguration"
      [paymentMethod]="payment"
      [selected]="(selectedPaymentMethod$ | async) === payment">
      <div id="payment-widget-{{ payment.code }}" iframe style="height: 450px;"></div>
      <div *ngIf="(selectedPaymentMethod$ | async) === payment && payment.isPurchaseOrderIdNeeded" [formGroup]="form"
           class="poField" poField
           style="padding-right: 24px; margin-top: 26px">
        <kion-input
          [form]="form"
          [invalid]="poField.invalid && (poField.dirty || poField.touched)"
          controlName="poField"
          id="poField"
          label="{{ 'checkout.steps.payment.poField.label' | translate }}"
          placeHolder="{{ 'checkout.steps.payment.poField.placeHolder' | translate }}">
          <div class="description"
               style="margin-left: 0">{{ 'checkout.steps.payment.poField.description' | translate }}</div>
          <ng-container *ngIf="poField.invalid && (poField.dirty || poField.touched)">
            <p *ngIf="poField.errors.required" class="error">
              {{ 'forms.required' | translate }}
            </p>
            <p *ngIf="poField.errors.maxlength" class="error">
              {{ 'forms.maxLength' | translate }}
            </p>
          </ng-container>
        </kion-input>
      </div>
    </kion-payment-item>
  </div>
  <div class="navigator">
    <div class="back">
      <kion-label-button [link]="backLink" [title]="'checkout.navigator.back' | translate">
        <svg height="20" img-link viewBox="0 0 16 16" width="20" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.286 4.571L2.522 4.571 6.118 0.975 5.31 0.167 0.335 5.143 5.31 10.118 6.118 9.31 2.522 5.714 14.286 5.714z"
            fill="#9B9B9E"
            fill-rule="evenodd"
            transform="translate(.571 2.857)"></path>
        </svg>
      </kion-label-button>
    </div>
    <div class="forward">
      <kion-button (clicked)="preAuthorize()" [disabled]="!(selectedPaymentMethod$ | async) || !(canProceed$ |async)"
                   [title]="'checkout.navigator.forward' | translate"
                   mode="primary"></kion-button>
    </div>
  </div>
</div>
